<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-4 mt-2">
      <i class="fa-solid fa-arrow-left mb-4" v-if="isBackButtonVisible" @click="goBack"></i>
      <h5 class="text-center flex-grow-1"><strong> {{ modalHeading }} </strong></h5>
    </div>

    <!--plan listing section-->
    <section class="table-section" v-if="!showPreview">

      <section>
        <p>Please select at least one category to continue</p>
        <multiselect class="custom-multiselect" :options="categoryList" :value="selectedCategories" track-by="value"
          placeholder="Select one or more categories" label="text" :multiple="true" :searchable="true"
          @select="onCategorySelect" @remove="onCategoryRemove" />

      </section>

      <section v-if="this.selectedCategories.length > 0">
        <div class="disclaimer">
          <p>Note:</p>
          <p>You can select one or multiple plans. On selecting a plan it will be added to cart which can be viewed
            using the preview button. Selecting plan from same category overrides the previous plan from that category.
          </p>
        </div>
        <p class="heading">Select Plans</p>

        <div class="table-wrapper">
          <table>
            <tbody>
              <tr v-for="(planDetail) in planList" :key="planDetail.category">
                <td class="category-cell">{{ planDetail.category }}</td>
                <td>
                  <div class="plan-list">
                    <plan-checkbox v-for="plan in planDetail.plans" :key="plan.value" :checkbox-item="plan"
                      @onChange="onCheckboxClicked" :checked="isChecked(plan)" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="preview-btn-wrapper">
          <button type="submit" class="new-quote-btn" @click="togglePreviewModal" v-if="cart !== null && cart.length > 0">Preview</button>
        </div>
      </section>
    </section>



    <!--Preview Modal-->
    <section v-else>
      <h6 class="fw-bold mb-2">Reveiw plans and pricing</h6>
      <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12">
        <div class="cart-list">
          <div class="table-responsive" style="overflow-x:unset !important">
            <table class="table" style="border-collapse:unset" v-if="cart !== null && cart.length > 0">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Total Price</th>
                </tr>
              </thead>
              <tbody style="max-height: 150px !important; overflow-y: scroll">
                <tr v-for="(plan, index) in cart" v-bind:key="index">
                  <td>
                    <div class="d-flex align-items-center gap-4">
                      <div class="vendor-img">
                        <img :src="`${plan.plan_logo}`" class="logo" />
                      </div>
                      <div>
                        <p class="mb-0"> {{ plan.plan_name }} </p>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div class="price">${{ plan.price }}</div>
                  </td>
                </tr>
              </tbody>
            </table>

            <section class="d-flex justify-content-center align-items-center" id="selected-plans-list" v-else>
              <p class="mb-0">No plans selected yet</p>
            </section>
          </div>
        </div>
      </div>

      <!-- Fee listing -->
      <div v-if="cart && fees">
        <p class="mt-4 mb-2 fw-bold">Processing Charges</p>
        <div class="procesing-fee">
          <p>One Time Processing Fee: <span>{{ `$ ${fees.oneTimeProcessingFee}` }}</span></p>
          <p>First Month Cost: <span>{{ `$ ${fees.firstMonthFee}` }}</span></p>
          <p>Recurring Month Cost: <span>{{ `$ ${fees.recurringFee}` }}</span> </p>
          <hr class="separator">
          <p>Total Cost: <span>{{ `$ ${fees.totalFee}` }}</span></p>
        </div>
      </div>


      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-end gap-2">
        <button type="submit" class="new-quote-btn close-preview-btn mt-4" @click="togglePreviewModal">Cancel</button>
        <button type="submit" class="new-quote-btn confirm-quote-btn mt-4" @click="submitQuote">Confirm</button>
      </div>
    </section>


  </div>
</template>

<script>
import PlanCheckBox from "./PlanCheckBox.vue";
import Api from "@/resource/Api";

export default {
  name: "PlanSelection",
  props: {
    quoteType: {
      type: String,
      required: true,
    },
    modalHeading: {
      type: String,
      required: true,
    },
    groupCensusId: {
      type: [Number, String],
    }
  },

  components: {
    "plan-checkbox": PlanCheckBox
  },

  computed: {
    isBackButtonVisible() {
      if (this.quoteType === "individual") return this.$store.getters.currentQuoteStep === 1; 
      if (this.quoteType === "group") return this.$store.getters.currentGroupQuoteStep === 1; 
      return false;
    }
  },

  data() {
    return {
      // planList: this.$store.getters.getAllPlans,
      planList: [],
      cart: [],
      fees: [],
      selectedPlanOptions: [],
      tempSelectedPlans: [],
      selectedCategories: [],
      showPreview: false,
      isCategorySelected: false,
      categoryList: this.$store.getters.planCategories,
      categoryHavingPlans: [],
    }
  },

  methods: {
    onCategorySelect(category) {
      if (!this.isCategorySelected) this.isCategorySelected = true;
      this.saveCategory(category);
      this.planList = [...this.$store.getters.getAllPlans.filter(item =>
        this.selectedCategories.map(category => category.value).includes(item.category))];
    },

    onCategoryRemove(category) {
      if (this.categoryHavingPlans.includes(category.value)) {
        this.$notify("This category contains selected plans", "error");
        return;
      }

      this.selectedCategories = [...this.selectedCategories.filter(item => item.value !== category.value)];
      this.planList = this.planList.filter(item => item.category !== category.value);
    },

    onCheckboxClicked(checkedItem) {
      const { item, checked } = checkedItem

      //ensuring the selectedPlans options is an array
      if (!Array.isArray(this.selectedPlanOptions)) this.selectedPlanOptions = [];


      //ensuring the checked plan is from different category
      if (checked) {
        if (this.selectedPlanOptions.length === 0) {
          this.selectedPlanOptions.push(item);
          this.tempSelectedPlans.push(item);
          this.saveCategoryHavingPlans(item.category)
        }

        else if (!this.checkPlanFromSameCategory(item)) {
          this.selectedPlanOptions.push(item);
          this.tempSelectedPlans = [];
          this.tempSelectedPlans.push(item);
          this.saveCategoryHavingPlans(item.category)
        }
        else {
          this.replacePlanFromExistingCategory(item);
          this.categoryHavingPlans.push(item);
        }
        this.addPlansToCart();
      }

      else {
        this.onCheckboxUnchecked(item);
        this.removeCategoryHavingPlans();

      }
    },

    onCheckboxUnchecked(item) {
      this.selectedPlanOptions = [...this.selectedPlanOptions.filter(plan => plan.pid !== item.pid)]
      this.removeCategoryHavingPlans();
      this.removePlanFromCart(item);
    },


    saveCategory(category) {
      if (!this.selectedCategories.includes(category)) this.selectedCategories = [...this.selectedCategories, category];
    },

    saveCategoryHavingPlans(category) {
      if (!this.categoryHavingPlans.includes(category)) this.categoryHavingPlans = [...this.categoryHavingPlans, category];
    },

    removeCategoryHavingPlans() {
      const categoryWithPlans = Array.from(new Set(this.selectedPlanOptions.map(item => item.category)));
      this.categoryHavingPlans = [...categoryWithPlans];
    },

    checkPlanFromSameCategory(item) {
      const categories = Array.from(new Set(this.selectedPlanOptions.map(item => item.category)));
      return categories.includes(item.category);
    },

    replacePlanFromExistingCategory(item) {
      const filteredPlans = this.selectedPlanOptions.filter(plan => plan.category !== item.category);
      this.selectedPlanOptions = [...filteredPlans, item];
      this.tempSelectedPlans = [item];
    },

    isChecked(item) {
     if (this.cart === null || this.cart.length === 0) return false

      const existingPlans = this.cart.map(plan => plan.plan_id_new);
      return existingPlans.includes(item.value);
    },

    togglePreviewModal() {
      this.showPreview = !this.showPreview;
    },

    goBack() {
      if (this.showPreview) this.togglePreviewModal();
      else if (this.quoteType === "individual") this.$store.commit('setCurrentIndividualQuoteStep', 0);
      else if (this.quoteType === "group") this.$store.commit('setCurrentGroupQuoteStep', 0);
    },

    addPlansToCart() {
      let url = "v2/quote/add-plans-to-cart";
      const plansToBeAdded = this.tempSelectedPlans.map(item => item.pid);
      const enrollmentID = this.quoteType == "individual" ? this.$store.getters.enrollmentId : this.quoteType == "group" ? this.$store.getters.memberEnrollmentID : "";
      const details = this.quoteType == "individual" ? this.$store.getters.individualDetails : this.quoteType == "group" ? this.$store.getters.groupMemberDetails : "";

      const payload = {
        enrollment_id: enrollmentID,
        pid: plansToBeAdded,
        dep_dob: details?.dep_dob,
        no_of_children: details?.no_of_children
      }

      this.cart = [];

      const loader = this.$loading.show();
      Api.post(url, payload).then((response) => {
        const cartArray = response.data.data[0].get_plan_cart_response.data.result;
        const plansInCart = cartArray.filter(item => cartArray.indexOf(item) !== cartArray.length - 1)
        this.fees = {
          firstMonthFee: response.data.data[0].get_plan_cart_response.data.initial_month_cost,
          totalFee: response.data.data[0].get_plan_cart_response.data.initial_month_cost,
          recurringFee: response.data.data[0].get_plan_cart_response.data.recurring_month_cost,
          oneTimeProcessingFee: response.data.data[0].get_plan_cart_response.data.result[cartArray.length - 1]["price"]
        }
        this.$notify(response.data.message)
        this.tempSelectedPlans = [];
        this.cart = plansInCart;
      }).catch((error) => {
        this.$notify(error.response.data.message || "Unable to save plan", "error")
      }).finally(() => {
        loader.hide()
      })
    },

    getCorrespondingPlanFromCart(plan) {
      const matchingPlan = this.cart.find(item => item.plan_id_new === plan.value) || [];
      const planID = matchingPlan?.plan_id;
      const planPricingID = matchingPlan?.plan_pricing_id;

      return { planID, planPricingID }
    },

    removePlanFromCart(plan) {
      const enrollmentID = this.quoteType == "individual" ? this.$store.getters.enrollmentId : this.quoteType == "group" ? this.$store.getters.memberEnrollmentID : "";
      const { planID, planPricingID } = this.getCorrespondingPlanFromCart(plan);
      const loader = this.$loading.show();
      const url = `v2/quote/remove-plan-from-cart?enrollment_id=${enrollmentID}&plan_id=${planID}&plan_pricing_id=${planPricingID}`
      Api.get(url).then(response => {
        const cartArray = response.data.data.get_plan_cart_response.data?.result;
        if (cartArray !== null && cartArray !== undefined && cartArray.length > 0) {
          const plansInCart = cartArray.filter(item => cartArray.indexOf(item) !== cartArray.length - 1)
          this.$notify(response.data.data.removePlanResponse.message)
          this.cart = [...plansInCart]
          this.fees = {
            firstMonthFee: response.data.data.get_plan_cart_response.data.initial_month_cost,
            totalFee: response.data.data.get_plan_cart_response.data.initial_month_cost,
            recurringFee: response.data.data.get_plan_cart_response.data.recurring_month_cost,
            oneTimeProcessingFee: response.data.data.get_plan_cart_response.data.result[cartArray.length - 1]["price"]
          }
        }
        else {
          this.$notify("You need to select at least one plan to proceed", "error")
          this.cart = null
        }
      }).catch((err) => {
        this.$notify(err.response.data.message)
      }).finally(() => {
        loader.hide()
      })
    },

    getGroupQuotePayload() {
      const categories = this.selectedCategoryOptions ? this.selectedCategoryOptions.map(item => item.value) : [];
      const enrollmentID = this.$store.getters.memberEnrollmentID;
      const memberDetails = this.$store.getters.groupMemberDetails;

      const payload = {};
      payload['enrollment_id'] = enrollmentID;
      payload["group_census_id"] = this.groupCensusId;
      payload["first_name"] = memberDetails["member_fname"];
      payload["last_name"] = memberDetails["member_lname"];
      payload["primary_fullname"] = memberDetails["member_fname"] + ' ' + memberDetails["member_lname"];
      payload["plan_type"] = memberDetails["tier"];
      payload["dob"] = memberDetails["dob"];
      payload["zip"] = memberDetails["zip_code"];
      payload["gender"] = memberDetails["gender"] === "M" ? "Male" : "Female";
      payload["email"] = memberDetails["email"];
      payload["category"] = categories;
      payload["relationship"] = "P"

      return payload;
    },

    getIndividualQuotePayload() {
      const categories = this.selectedCategoryOptions ? this.selectedCategoryOptions.map(item => item.value) : [];
      const enrollmentID = this.$store.getters.enrollmentId;
      const payload = this.$store.getters.individualDetails;
      const plans = this.cart ? this.cart.map(item => String(item.plan_id)) : [];


      payload["category"] = categories;
      payload["enrollment_id"] = enrollmentID
      payload["plans"] = plans;

      return payload;
    },

    updateGroupDetailsInStore() {
      this.$store.commit("setGroupMemberDetails", {});
      this.$store.commit('setCurrentGroupQuoteStep', 0);
      this.$store.commit('setPlanData', []);
    },

    updateIndividualDetailsInStore() {
      this.$store.commit("setBasicIndividualDetails", {});
      this.$store.commit('setCurrentIndividualQuoteStep', 0)
      this.$store.commit('setPlanData', []);
    },

    hideModal() {
      const modalID = this.quoteType == "individual" ? "personalized-quote-modal" : this.quoteType == "group" ? "group-quote-member-add" : "";
      this.$bvModal.hide(modalID);
    },


    getSubmitQuotePayload() {
      return this.quoteType == "individual" ? this.getIndividualQuotePayload() : this.quoteType == "group" ? this.getGroupQuotePayload() : "";
    },

    getSubmitQuoteURL() {
      return this.quoteType == "individual" ? "v2/quote/store" : this.quoteType == "group" ? "v2/quote/store-groupquote-member" : "";
    },

    updateDetailsInStore() {
      this.quoteType == "individual" ? this.updateIndividualDetailsInStore() : this.quoteType == "group" ? this.updateGroupDetailsInStore() : false;
    },

    submitQuote() {
      if (this.cart == null || !this.cart.length > 0) {
        this.$notify('You must have at least one plan to proceed', "error")
      }

      else {
        const url = this.getSubmitQuoteURL();
        const payload = this.getSubmitQuotePayload();

        const loader = this.$loading.show();
        Api.post(url, payload).then(response => {
          this.$notify(response.data.message);
          this.hideModal();

          this.selectedPlanOptions = [];
          this.selectedCategoryOptions = [];
          this.tempSelectedPlans = [];

          if(this.quoteType === "individual") this.$store.dispatch('fetchIndividualQuotes');
          if(this.quoteType === "group") this.$store.dispatch('fetchGroupQuotes');
        }).catch((error) => {
          this.$notify(error.response?.data?.message, "error")
        }).finally(() => {
          loader.hide();
        })
      }
    }
  }
}
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

.table-wrapper {
  max-height: 350px;
  overflow-y: scroll;
}

.table-section {
  display: flex;
  flex-direction: column;
  gap: .75rem;
}

td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  border: 1px solid #ddd;
  padding: 8px;
  background-color: #f2f2f2;
  text-align: left;
}

tr {
  padding: .75rem .35rem;
}

tr:hover {
  background-color: #f5f5f5;
}

.category-cell {
  vertical-align: top;
  font-weight: bold;
  text-transform: capitalize;
  padding: .5rem .35rem !important;
}

.preview-btn-wrapper {
  display: flex;
  justify-content: flex-end;
}

.preview-btn-wrapper button {
  max-width: fit-content;
}

.heading {
  font-size: 1.15rem;
  font-weight: 600;
  margin-bottom: 0;
}

.disclaimer {
  display: flex;
  padding: .25rem 1.5rem;
  width: 100%;
  gap: .75rem;
  border: .15rem solid #e49300;
  background-color: #fff6da;
  border-radius: .5rem;
  margin-bottom: .75rem;
}

.disclaimer p {
  margin: 0;
}

.disclaimer p:first-of-type {
  font-weight: 700;
}

.procesing-fee {
  background: #e8e8e8;
  color: black;
  padding: 1.25rem 1.5rem 1.5rem 1.15rem;
  border-radius: .75rem;
  min-width: fit-content;
}

.procesing-fee p {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
}

.procesing-fee p:last-of-type {
  margin-bottom: 0;
}

.logo {
  width: 60px;
  height: 60px;
  object-fit: contain;
  mix-blend-mode: multiply;
}

#selected-plans-list {
  border: .15rem dashed rgba(184, 184, 184, 0.39);
  border-radius: .75rem;
}

#selected-plans-list p {
  padding: 1.5rem 0;
  font-weight: bold;
  color: grey;
}

.confirm-quote-btn,
.close-preview-btn{
max-width: fit-content !important;
}

.close-preview-btn {
  background: red !important;
}
</style>